<template>
  <div class="main-wrapper">
    <div @click="menuActive = !menuActive" class="menu-burger">
      <div class="menu-burger__inside">
        <span class="menu-burger__item"></span>
        <span class="menu-burger__item"></span>
      </div>
    </div>

    <div v-if="loader" class="loader--wrapper">
      <span class="loader"></span>
    </div>

    <div :class="{'menu-blur': true, 'menu-blur--show': menuActive}" @click="menuActive=false"></div>
    <div :class="{'menu flex flex-col justify-between': true, 'menu--active': menuActive}" :style="{paddingTop: isPlacement ? '30px' : '40px' }">
      <div class="">
        <span v-if="!isPlacement" class="logo">task-board
          <sup>
            <span class="color__x">x</span>24
          </sup>
        </span>

        <menu-left :list="menuLeft"></menu-left>

        <div class="company">
          <div class="company__name">
            <template v-if="site">{{ site }}</template>
            <template v-else>{{ requisite.name }}</template>
          </div>
          <template v-if="site">
            {{ requisite.name }}<br>
          </template>
          <template v-if="requisite.inn">
            ИНН {{ requisite.inn }}<br>
          </template>
          <template v-if="requisite.kpp">
            КПП {{ requisite.kpp }}
          </template>
        </div>
      </div>

      <div class="company">
        Powered by <a href="https://legacy-agency.ru/" target="_blank">Legacy</a>
      </div>
    </div>

    <div class="content">
      <div class="content__content" :style="{paddingTop: isPlacement ? '30px' : '50px' }">

        <div v-if="errorMessage" class="text-red-700 mb-4 font-bold">{{ errorMessage }}</div>

        <router-view></router-view>
      </div>
    </div>

    <task-detail-dialog
      :open="taskDetailDialogStore.open"
      :loading="taskDetailDialogStore.loading"
      :detail="taskDetailDialogStore.detail"
      :task="taskDetailDialogStore.task"
      :error="taskDetailDialogStore.error"
      @close="taskDetailDialogStore.closeDialog"
    />
  </div>
</template>

<script>
// Store
import { mapState, mapStores } from 'pinia/dist/pinia'
import { useCompanyStore } from '@/stores/company'
import { useDocsStore } from '@/stores/docs'
import { useTasksStore } from '@/stores/tasks'
import { useFinStore } from '@/stores/fin'
import { useTaskDetailDialogStore } from '@/stores/taskDetailDialog'
// ...
import axios from 'axios'
import { nextTick } from 'vue'
// Компоненты
import MenuLeft from '@/components/MenuLeft'
import TaskDetailDialog from '@/components/TaskDetailDialog'

export default {
  name: 'App',
  components: {
    MenuLeft,
    TaskDetailDialog,
  },
  data () {
    return {
      loader: false,
      menuActive: false,
      errorMessage: '',
    }
  },
  computed: {
    ...mapState(useCompanyStore, ['companyName', 'site', 'requisite', 'sysObject']),
    ...mapStores(useDocsStore, useTasksStore, useCompanyStore, useFinStore, useTaskDetailDialogStore),
    menuLeft () {
      return this.$router.getRoutes()
    },
    isPlacement() {
      return !!window?.legacySysObject
    }
  },
  methods: {
    changePage(newValue) {
      this.component = newValue
    }
  },
  mounted () {
    if (window.innerWidth > 1100) {
      this.menuActive = true
    }

    this.$router.afterEach(() => {
      this.tasksStore.selectedItems = []
      this.taskDetailDialogStore.closeDialog()
      if (window.innerWidth <= 1100) {
        this.menuActive = false
      }
    })

    nextTick().then(async () => {
      if (this.isPlacement) {
        this.$router.push({ name: 'PageCurrent' })
      }

      this.loader = true
      let res = await axios.get('/api/getMore', {
        params: this.sysObject
      })

      this.loader = false

      let data = res.data
      if (!data.success) {
        this.errorMessage = data.errorMessage
      }

      // Задачи
      this.tasksStore.setList(data.tasks)
      this.tasksStore.setStatusList(data.stage)

      // Документы
      this.docsStore.setList(data.docs)

      // Компания
      if (data.company) {
        this.companyStore.setCompany(data.company)
      }

      // Прокидываем ставку компании в finStore
      this.finStore.setCompany()
    })
  }
}
</script>

<style lang="scss">
  .company {
    color: #3e4853;
    margin: 26px 0 14px 16px;
    font-size: 11px;

    &--normal {
      font-size: inherit;
    }
  }

  .company__name {
    text-transform: uppercase;
    font-weight: bold;
  }

  .logo {
    font-size: 15px;
    font-weight: 700;
    color: #056dbd;
    padding-left: 15px;
    margin-bottom: 20px;
    display: block;
    text-transform: uppercase;

    sup {
      text-transform: lowercase;
      color: #12b981;
    }
  }

  .logo__x {
    color: #8080807d;
  }

  .company-name {
    font-size: 13px;
    margin: 20px 0 0 16px;
  }
</style>
